import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { fetchWithAuth } from "@/lib/api";

export interface HistoryFilterOptions {
  branches: { id: number; name: string; brandId: number }[];
  drivers: { id: number; name: string | null }[];
}

export function useHistoryFilterOptions() {
  const { getAccessToken, user, userDataLoading, isLoading } = useAuth();
  const [options, setOptions] = useState<HistoryFilterOptions>({
    branches: [],
    drivers: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    if (isLoading || userDataLoading) return;
    setLoading(true);
    setOptions({ branches: [], drivers: [] });
    setError(null);
    getAccessToken()
      .then((token) => fetchWithAuth("/order/orders/history/options", token))
      .then((result) => {
        if (!cancelled) setOptions(result);
      })
      .catch((err) => {
        if (!cancelled)
          setError(
            err instanceof Error
              ? err.message
              : "No se pudieron cargar los filtros.",
          );
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [user?.email, isLoading, userDataLoading, getAccessToken]);
  return { options, loading, error };
}
